
export default function initAsOAuth () {
    // this.init(); called on the hook instead..
    const syncStore = this.env.syncStore;
    const sessionSettings = this.env.page.sessionSettings;
    const sess = this.env.oauthSession;
    const languageStore = this.env.languageStore;
    console.log('initAsAuth() sessionSettings ', sessionSettings);
    console.log('initAsOAuth(): ', this.oauthSessionId);
    languageStore.setTranslations(sessionSettings.translations);
    /*
        DO NOT DELETE Reference of the Sync Required Params for Google and Outlook oauth.
        apiKey
        oauthSessionId
        browser
        calendar
        locale
    */

    syncStore.sync({
        ...sess,
        publisherId: `${sessionSettings?.widget?.publisherId}`,
    });
  
    /*
    syncStore.sync({
        ...sessionSettings,
        calendar: sessionSettings.selectedCalendar,
        publisherId: `${sessionSettings.widget.publisherId}`,
    });
    */
}
